module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAATZJREFUWEdjZBhgwDjA9jOMOoDoENi/fz8HF7/sZIb/DCEMDAwC2KLuP8P/L0wMDHO+fnpS6ejo+IOY6CXaAafO3u7/z8BYQIyhDP8Z5pibqKQSo5ZoB5w4e/szIwMjz+8/f0xtzDXOYDP8yMkbJqwsLKcZGBg+mBurCFLVASfP3vkPMtDcWAWvo4lVB3MchmEnz94B+cCEGNeToeaMubGKKbK+wecAmOtIDUpcoUHIHJzxSUgjscFPyJxRB5AcAtBcAsqOKKkZjzje7EuOA7AaiCuuqZ4GSLVo1AGjITAaArQIAVB1PXAFEbGVELG1Kskl4agD6BkCrxkYGERItRC7+v9vzI1VRbHJ4U4D5+96M/z9t4CBkZEyR/z//4aBgSnB3ER5K0kOoI7PCZtCdMeEsFHkqQAADusjMJh0dvEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/icon_delete@2x.png
// module id = tO8W
// module chunks = 1